import { SankeyFlow } from '../../diagram/types';

interface Props {
  formatAmount: (amount: number) => string;
  flows: SankeyFlow[];
  amount: number;
}

// Returns a text showing the flow amounts which add up to a node's total value in or out.
const ImbalanceValue: React.FC<Props> = ({ formatAmount, flows, amount }) => {
  const formattedSum = formatAmount(amount);
  if (flows.length === 1) {
    return <>{formattedSum}</>;
  }
  // When there are multiple amounts, the amount appears as a hover
  // target with a tooltip showing the breakdown in descending order.
  const breakdown = flows
    .map((f) => Number(f.amount))
    .sort((a, b) => b - a)
    .map(formatAmount)
    .join(' + ');

  return (
    <dfn title={`${formattedSum} from ${flows.length} Flows: ${breakdown}`}>
      {formattedSum}
    </dfn>
  );
};

export default ImbalanceValue;
